import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, useTokenValidation } from '@sib/auth';

export interface ProtectedRouteProps {
  fallbackPath: string;
}

export const ProtectedRoute = ({
  fallbackPath,
  children,
}: PropsWithChildren<ProtectedRouteProps>) => {
  useTokenValidation();
  const { isAuthenticated } = useAuthStore();

  return isAuthenticated ? <>{children}</> : <Navigate to={fallbackPath} />;
};
